import * as actionTypes from './actionTypes';

export const setIdAndCount=(one)=>({
    type:actionTypes.SET_ID_AND_COUNT,
    payload:one
})